<div id="globalPageStatus" *ngIf="globalPageStatusText != null && globalPageStatusText.length > 0">{{globalPageStatusText}}</div>
<div id="pageStatus" *ngIf="pageStatusText != null && pageStatusText.length > 0">{{pageStatusText}}</div>